import whenDomReady from 'when-dom-ready';
import { tns } from 'tiny-slider/src/tiny-slider';
const ACTIVE = 'is-active';
const SINGLE = 'single-btn';
function initialise() {
    const sections = document.querySelectorAll('.js-tabbed-section');
    sections.forEach(initialiseSection);
}
export function initialiseSection(section) {
    const nav = section.querySelector('.js-tabbed-nav');
    if (!nav) {
        return;
    }
    const track = section.querySelector('.js-tabbed-track');
    const accordionItems = section.querySelectorAll('.js-accordion-item');
    const navItems = nav.querySelector('.tabbed-section__nav-list');
    if (!nav || !track) {
        return;
    }
    // Setup slider instance.
    const instance = tns({
        arrowKeys: false,
        autoplay: false,
        center: true,
        items: 1,
        container: track,
        controls: false,
        gutter: 160,
        loop: false,
        mouseDrag: false,
        nav: false,
        touch: false,
        autoHeight: true,
    });
    instance.events.on('indexChanged', onIndexChanged);
    // Setup navigation buttons.
    const buttons = nav.querySelectorAll('button');
    if (buttons && buttons.length) {
        buttons.forEach((button) => {
            button.addEventListener('click', onButtonClick);
        });
        if (buttons.length === 1) {
            buttons.forEach((button) => {
                button.classList.add(SINGLE);
            });
        }
    }
    // Setup navigation select.
    const select = nav.querySelector('select');
    if (select) {
        select.addEventListener('change', onSelectChange);
    }
    /**
     * Handle navigation button click.
     * @param event
     */
    function onButtonClick(event) {
        event.preventDefault();
        if (event.target instanceof HTMLElement) {
            const target = parseInt(event.target.dataset.target || '0', 10);
            instance.goTo(target);
        }
        if (accordionItems) {
            accordionItems.forEach((accordionItem) => {
                accordionItem.classList.remove(ACTIVE);
            });
        }
    }
    /**
     * Handle navigation anchor/hash.
     */
    if (navItems) {
        window.addEventListener('hashchange', createHashChangeListener(instance, nav, navItems));
    }
    /**
     * Handle slider index change.
     */
    function onIndexChanged(info) {
        buttons.forEach((button) => button.classList.remove(ACTIVE));
        const activeButton = buttons[info.index];
        if (activeButton) {
            activeButton.classList.add(ACTIVE);
        }
        if (select) {
            select.value = info.index.toString(10);
        }
        if (accordionItems) {
            accordionItems.forEach((accordionItem) => {
                accordionItem.classList.remove(ACTIVE);
            });
        }
        if (accordionItems) {
            accordionItems.forEach((accordionItem) => {
                const content = accordionItem.querySelector('.js-accordion-content');
                if (!content) {
                    return;
                }
                calculateHeight(content);
            });
        }
    }
    /**
     * Handle navigation select change.
     * @param event
     */
    function onSelectChange(event) {
        if (event.target instanceof HTMLSelectElement) {
            const target = parseInt(event.target.value, 10);
            instance.goTo(target);
            updateHash(target + 1); // Update hash when select is changed
        }
    }
    if (accordionItems) {
        accordionItems.forEach((accordionItem) => {
            const content = accordionItem.querySelector('.js-accordion-content');
            if (!content) {
                return;
            }
            calculateHeight(content);
        });
    }
}
/**
 * Update the hash in the URL.
 * @param index
 */
function updateHash(index) {
    window.location.hash = index.toString();
}
/**
 * Remove the hash in the URL.
 */
function removeHash() {
    history.pushState('', document.title, window.location.pathname + window.location.search);
}
/**
 * Update the slider based on the current hash.
 */
function updateSliderFromHash(instance, nav, navItems) {
    const hash = window.location.hash.substring(1); // Get the hash without the '#'
    if (hash && /^\d+$/.test(hash)) {
        // Check if hash contains only digits
        const index = parseInt(hash, 10) - 1; // Convert hash to index (assuming hash is 1-based)
        if (instance) {
            instance.goTo(index); // Navigate to the slide
        }
        if (nav && navItems) {
            const navHeight = getNavHeight();
            window.scrollTo(0, getTopOffset(navItems) - navHeight - 32);
        }
    }
}
// Get reliable top position of given element (works even in Safari)
function getTopOffset(element) {
    const rect = element.getBoundingClientRect();
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    return rect.top + scrollTop;
}
function getNavHeight() {
    const mainNav = document.querySelector('.js-header');
    let navHeight = 150;
    if (mainNav) {
        navHeight = mainNav.getBoundingClientRect().height;
    }
    const subNav = document.querySelector('.js-subnav');
    if (subNav) {
        navHeight = navHeight + subNav.getBoundingClientRect().height;
    }
    return navHeight;
}
function createHashChangeListener(instance, nav, navItems) {
    return function () {
        updateSliderFromHash(instance, nav, navItems);
        removeHash();
    };
}
/**
 * Calculate the max height of the specified element.
 * @param element
 */
function calculateHeight(element) {
    // Cache current value.
    const currentMaxHeight = element.style.maxHeight;
    // Remove max height.
    element.style.maxHeight = 'none';
    // Get current height value.
    const { height } = element.getBoundingClientRect();
    element.style.setProperty('--height', `${height}px`);
    // Reset style back to cached value.
    element.style.maxHeight = currentMaxHeight;
    return height;
}
whenDomReady().then(initialise);
